import { render } from "./Metrics.vue?vue&type=template&id=7820832a&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=7820832a&scoped=true&lang=less"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7820832a"]])

export default __exports__